// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".testimonial[data-v-61881416]{padding:0 50px}@media(max-width:600px){.testimonial[data-v-61881416]{padding:0}}.prompt[data-v-61881416]{color:#313b59;font-size:16px;line-height:1.4;margin-bottom:16px;margin-top:8px;text-align:left}.rating-container[data-v-61881416]{margin:10px 0}.review-required-text[data-v-61881416]{color:#d93025;font-size:14px;margin-top:10px}.btn-submit-review[data-v-61881416]{display:block;height:36px;margin:20px 0;width:100%}", ""]);
// Exports
module.exports = exports;
